import React from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";

/**
 * withRouter -- React Router v6 훅을 class component에 주입하는 HOC
 *
 * React Router v6은 v5의 withRouter를 제거했으므로 훅을 class에 쓰려면
 * functional wrapper를 직접 만들어야 한다.
 *
 * @param {React.ComponentType} Component -- 감쌀 class component
 * @returns {React.FC} -- searchParams/setSearchParams/location/navigate를 주입한 wrapper
 */
export function withRouter(Component) {
    function WithRouterWrapper(props) {
        const [searchParams, setSearchParams] = useSearchParams();
        const location = useLocation();
        const navigate = useNavigate();
        return (
            <Component
                {...props}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                location={location}
                navigate={navigate}
            />
        );
    }
    WithRouterWrapper.displayName = `withRouter(${Component.displayName || Component.name || "Component"})`;
    return WithRouterWrapper;
}

export default withRouter;
